import common_colors from './common_colors';

export default {
  cardHeader: '#F4F7F9',
  cardContainer: '#FFFFFF',
  cardInternalContent: '#FFFFFF',
  cardLightBorder: '#EAEAEA',
  cardBorder: '#9CA3AF',

  navItemActive: '#DFF2FD',

  textPrimary: '#000000',
  textSecondary: '#56595C',
  textLink: '#0EA5E9',
  textLinkVisited: '#C589F9',

  buttonBlue: '#137CC3',
  buttonFooterBackground: '#A5A5A5',

  pageBackground: '#FFFFFF',
  defaultWindowBg: '#EAEAEA',
  defaultBackground: '#FFFFFF',
  disabledBackground: '#E3E3E3',
  activeItemBackground: '#EAEAEA',

  statusBarBackground: '#137CC3',
  statusBarBackgroundAndroid: '#0C74AD',
  bottomBarBackground: '#FFFFFF',
  menuPopupBackground: '#EAEAEA',

  calendarWeekdayHeader: '#137CC3',
  calendarDayHeader: '#bbd9e9',

  loginButtonBorder: '#000000',
  facebookButtonColor: '#4267B2',

  redResults: '#a93636',
  greenResults: '#38761d',

  ...common_colors,
};
